import { useState, useEffect } from 'react';
import firebase from '../config/firebase.config';

/**
 * Label for membersDatabase activeTeamId (under activeCompanyId), client Firestore only.
 */
export function useSavedActiveTeamLabel(userUID) {
  const [label, setLabel] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!userUID) {
      setLabel(null);
      setLoading(false);
      return;
    }

    const db = firebase.firestore();
    const memberRef = db.collection('membersDatabase').doc(userUID);

    const unsub = memberRef.onSnapshot(
      async (snap) => {
        const d = snap.data();
        if (!d) {
          setLabel(null);
          setLoading(false);
          return;
        }
        const cid = d.activeCompanyId;
        const tid = d.activeTeamId;
        if (!cid || !tid) {
          setLabel(null);
          setLoading(false);
          return;
        }
        try {
          const teamSnap = await memberRef
            .collection('companyList')
            .doc(cid)
            .collection('teamList')
            .doc(tid)
            .get();
          const name = teamSnap.data()?.Team || tid;
          setLabel(name);
        } catch (e) {
          console.error('[useSavedActiveTeamLabel]', e);
          setLabel(tid);
        } finally {
          setLoading(false);
        }
      },
      (err) => {
        console.error('[useSavedActiveTeamLabel]', err);
        setLabel(null);
        setLoading(false);
      }
    );

    return () => unsub();
  }, [userUID]);

  return { savedActiveTeamLabel: label, savedActiveTeamLoading: loading };
}
